// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shaymin_sky: PokeData = {
  "id": 10006,
  "name": "shaymin-sky",
  "height": 4,
  "weight": 52,
  "base_experience": 270,
  "types": [
    PokeType.GRASS,
    PokeType.FLYING
  ],
  "api_moves": [
    "leech-seed",
    "growth",
    "quick-attack",
    "sweet-kiss",
    "sweet-scent",
    "magical-leaf",
    "natural-gift",
    "worry-seed",
    "air-slash",
    "energy-ball",
    "leaf-storm",
    "seed-flare",
    "play-rough"
  ],
  "moves": [
    "quick-attack",
    "sweet-kiss",
    "air-slash",
    "energy-ball",
    "play-rough",
    "aerial-ace",
    "peck",
    "aromatherapy",
    "grassy-terrain",
    "brave-bird",
    "power-whip",
    "roost",
    "branch-poke"
  ],
  "evolution_chain": {
    "id": 253,
    "item": null,
    "species": [
      {
        "name": "shaymin",
        "order": 493,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 105,
    "speed": 152,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
